import apiClient from "../../../../../services/apiClient";

export const benefitsAPI = {
    
  getApprovedBenefits: async (email, dateFrom, dateTo) => {
    const link = `get_appr_benefits?email=${email}&dateFrom=${dateFrom}&dateTo=${dateTo}`;

    const ret = await apiClient.get(link);

    if(ret.data) return { success: true, data: ret.data };
    
    return { success: false, error: 'No data received' };

    
  }
};